<div class="searchable-select">
  <input
    type="search"
    [ngModel]="internalValue"
    (ngModelChange)="onChange($event)"
    (click)="isOpen = !isOpen"
    [placeholder]="placeholder()"
  />
  @if (isOpen) {
    <div class="searchable-select__dropdown">
      @for (item of filteredItems; track item.value) {
        <div
          (click)="select(item)"
          (keydown.enter)="select(item)"
          class="searchable-select__item"
          tabindex="0"
        >
          {{ item.label }} ({{ item.value }})
        </div>
      }
    </div>
  }
  <div class="searchable-select__arrow" [class.open]="isOpen"></div>
</div>
